import { SubscriptionIdTypes } from './SubscriptionIdTypes';
import { SubscriptionTypes } from './SubscriptionTypes';

type T = SubscriptionTypes;

type X<T extends SubscriptionTypes> = typeof SubscriptionIdTypes[T];

// Map to get the keys for comparison between the update criterias of the subscription.
export const SubscriptionIdTypeGetters = new Map<T, Array<(x: X<T>) => string | number | null>>([
    [
        SubscriptionTypes.AlertAggregate,
        [(_: typeof SubscriptionIdTypes[SubscriptionTypes.AlertAggregate]) => null]
    ],
    [
        SubscriptionTypes.Area,
        [(x: typeof SubscriptionIdTypes[SubscriptionTypes.Area]) => x.moduleId]
    ],
    [
        SubscriptionTypes.Alert,
        [(x: typeof SubscriptionIdTypes[SubscriptionTypes.Alert]) => x.sensorId]
    ],
    [
        SubscriptionTypes.Sensor,
        [(x: typeof SubscriptionIdTypes[SubscriptionTypes.Sensor]) => x.sensorId]
    ],
    [
        SubscriptionTypes.RtuStatus,
        [(x: typeof SubscriptionIdTypes[SubscriptionTypes.RtuStatus]) => x.hardwareItemId]
    ],
    [
        SubscriptionTypes.SensorUpdate,
        [(x: typeof SubscriptionIdTypes[SubscriptionTypes.SensorUpdate]) => x.sensorId]
    ],
    [
        SubscriptionTypes.ViewModel,
        [(x: typeof SubscriptionIdTypes[SubscriptionTypes.ViewModel]) => x.identifier.entityId]
    ],
    [
        SubscriptionTypes.HardwareItemSyncLoadingStatus,
        [(_: typeof SubscriptionIdTypes[SubscriptionTypes.HardwareItemSyncLoadingStatus]) => null]
    ],
    [
        SubscriptionTypes.DeviceStatus,
        [(x: typeof SubscriptionIdTypes[SubscriptionTypes.DeviceStatus]) => x.hardwareItemId]
    ],
    [
        SubscriptionTypes.DeviceAutoCommission,
        [(x: typeof SubscriptionIdTypes[SubscriptionTypes.DeviceAutoCommission]) => x.username]
    ],
    [
        SubscriptionTypes.AreaAssignment,
        [(x: typeof SubscriptionIdTypes[SubscriptionTypes.AreaAssignment]) => x.moduleId]
    ],
    [
        SubscriptionTypes.ModuleRegistrationAlertSubscription,
        [(x: typeof SubscriptionIdTypes[SubscriptionTypes.ModuleRegistrationAlertSubscription]) => x.moduleId]
    ],
    [
        SubscriptionTypes.DeviceHardwareItemSyncSuccess,
        [(_: typeof SubscriptionIdTypes[SubscriptionTypes.DeviceHardwareItemSyncSuccess]) => null]
    ],
    [
        SubscriptionTypes.DeviceRemoved,
        [(_: typeof SubscriptionIdTypes[SubscriptionTypes.DeviceRemoved]) => null]
    ],
    [
        SubscriptionTypes.JobProfileUpserted,
        [
            (x: typeof SubscriptionIdTypes[SubscriptionTypes.JobProfileUpserted]) => x.jobNumber,
            (x: typeof SubscriptionIdTypes[SubscriptionTypes.JobProfileUpserted]) => x.jobHeaderId,
        ]
    ],
    [
        SubscriptionTypes.UserSpecificLoadingStatus,
        [(x: typeof SubscriptionIdTypes[SubscriptionTypes.UserSpecificLoadingStatus]) => x.username]
    ]
]);
